export default "__VITE_ASSET__CETLz_2R__"